export const RPC = "https://data-seed-prebsc-2-s3.binance.org:8545";
